<template>
    <div style="min-height: 130px">
      <TrfHeader v-if="showTitle" pageTitle="Transferir responsável" />
      <div class="component-content">
        <TrfCardInfo
            v-if="dadosEdicao.isAvulsa"
            mensagem='Caso o departamento selecionado possua um responsável configurado na empresa, esse responsável será atribuído 
            automaticamente à tarefa se o campo "Novo responsável" não for preenchido. Caso contrário, a tarefa ficará sem um responsável.'
        />

      <div class="columns">
        <div v-if="dadosEdicao.isAvulsa" class="column is-9-desktop is-12-mobile">
            <label>Novo departamento</label>
            <Multiselect
                :searchable="true"
                :options="departamentosAsOptions"
                v-model="formData.departamentoId"
                class="multiselect-econtador"
                placeholder="Selecione o novo departamento desta tarefa"
                noResultsText="Departamento não encontrado"
                id="select-departamento-modal-transferencia"
            />
        </div>

        <div class="column is-9-desktop is-12-mobile" >
          <label>Novo responsável</label>
          <Multiselect
              :searchable="true"
              :options="responsaveisAsOptions"
              v-model="formData.responsavelId"
              :class="{'multiselect-econtador':true,'select is-loading is-inline-block': isLoading}"
              placeholder="Selecione o novo responsável pela tarefa"
              noResultsText="Responsável não encontrado"
              id="select-responsavel-modal-transferencia"
          />
          </div>
      </div>
      <div v-if="showButtons" class="buttons">
        <TrfButton @click="doSalvar()" nome="Salvar" classCor="isLoading = true;-primary" id="btn-form-transferencia-salvar"></TrfButton>
        <TrfButton @click="doCancelar()" nome="cancelar" classCor="isLoading = true;-white" id="btn-form-transferencia-cancelar"></TrfButton>
      </div>
    </div>
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { departamentoUtils } from '../../util/departamento.utils.js';

export default {
  name: 'TrfFromTransferenciaResponsavel',
  emits: ['update:form-data'],
  components: {
    TrfHeader: defineAsyncComponent(() => import('../Header/index.vue')),
    Multiselect: defineAsyncComponent(() => import("@vueform/multiselect")),
    TrfCardInfo: defineAsyncComponent(() => import("../CardInfo/index.vue")),
    TrfButton: defineAsyncComponent(() => import('../Button/index.vue')),
  },
  props: {
    showButtons: {
      type: Boolean,
      default: true
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    dadosEdicao: {
        type: Object,
        default: Object.assign({}, {})
    },
    departamentos: {
        type: [Array, null],
        default: null
    },
    responsaveis: {
        type: [Array, null],
        default: null
    },
    itemEdicao: {
      type: Object,
      default: Object.assign({}, {})
    }
  },
  data() {
    return {
      formData: {
        departamentoId: '',
        responsavelId: '',
        responsavelNome: ''
      },
      data: {
        departamentos: this.departamentos,
        responsaveis: this.responsaveis
      },
      loadings: {
        departamentos: this.departamentos != null,
        responsaveis: this.responsaveis != null
      },
      isLoading: false
    };
  },
  computed: {
    departamentosAsOptions() {
      if (!Array.isArray(this.data.departamentos)) return [];
      const departamentosAsOptions = departamentoUtils.converterDepartamentosEmDepartamentosDTO(this.data.departamentos);
      return departamentosAsOptions
    },
    responsaveisAsOptions() {
        return this.data.responsaveis
    },
    validacoes() {
      const isResponsavelValido = !!this.formData.responsavelId;
      const isDepartamentoValido = !!this.formData.departamentoId;
      const isFormValido = isResponsavelValido && isDepartamentoValido;
      const validacoes = {
        form: isFormValido,
        campos: {
          departamentoId: isDepartamentoValido,
          responsavelId: isResponsavelValido
        }
      };
      return validacoes;
    }
  },
  watch: {
    formData: {
      immediate: true,
      handler() {
        this.setResponsavelNome()
        this.$emit('update:form-data', this.formData)
      },
      deep: true
    },
  },
  methods: {
    filterResponsaveisOptions(departamentoId) {
      const filteredResponsaveis = this.data.responsaveis.filter(
        element => element.acessaTodosDepartamentos || (!element.acessaTodosDepartamentos && element.idsDepartamentos.includes(departamentoId))
      );
      this.data.responsaveis = filteredResponsaveis;
    },
    async getUsuarioService() {
      const { usuarioService } = await import('../../service/usuario-service.js');
      return usuarioService
    },
    setResponsavelId(valor = '') {
      this.formData.responsavelId = valor;
    },
    setResponsavelNome(valor = '') {
      if (this.data.responsaveis && this.formData.responsavelId) {
          this.formData.responsavelNome = this?.data?.responsaveis.find((element)=>element.value == this.formData.responsavelId)?.label
        }
    },
    setDepartamentoId(valor = '') {
      this.formData.departamentoId = valor;
    },
    doReset() {
      // limpar selects e validações aqui
      this.formData = {
        responsavelId: '',
        responsavelNome: '',
        departamentoId: ''
      }
    },
    async doSalvar() {
      //efetua save
    },
    marcarValidacoes() {
      if (!this.validacoes.campos.responsavelId) {
        //marcar Select de responsavel aqui
      }
      if (!this.validacoes.campos.departamentoId) {
        //marcar select de departamento aqui
      }
    },
    async carregarDepartamentos() {
      try {
        this.loadings.departamento = true
        this.data.departamentos = await departamentoUtils.adquirirTodosOsDepartamentos();
      } catch (e) {
        console.warn(`WARN: ${e}`)
      } finally {
        this.loadings.departamento = false
      }
    },
    async carregarResponsaveis() {
      try {
        this.loadings.responsaveis = true
        const usuarioService = await this.getUsuarioService();
        this.data.responsaveis = await usuarioService.listarResponsaveis();
      } catch (e) {
        console.warn(`WARN: ${e}`)
      } finally {
        this.loadings.departamento = false
      }
    },
    async atribuirResponsavelPadrao(item) {
      this.isLoading = true;

      const usuarioService = await this.getUsuarioService();

      let responsavel = "";

      if (item.isProcesso) {
        responsavel = await usuarioService.getResponsavelByProcesso(item.id);
      }

      if (item.isFase) {
        responsavel = await usuarioService.getResponsavelByFase(item.id);
      }

      this.formData.responsavelId = responsavel?.id;

      this.isLoading = false;
    }
  },
  async mounted() {
    if (this.responsaveis === null) {  
      await this.carregarResponsaveis()
    }
    if (this.departamentos === null) {
      await this.carregarDepartamentos()
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
